import { render, staticRenderFns } from "./email.component.vue?vue&type=template&id=70d731c7&scoped=true"
import script from "./email.component.vue?vue&type=script&lang=js"
export * from "./email.component.vue?vue&type=script&lang=js"
import style0 from "./email.component.vue?vue&type=style&index=0&id=70d731c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d731c7",
  null
  
)

export default component.exports